import {
  MsalService,
  MSAL_GUARD_CONFIG,
  MsalGuardConfiguration,
} from '@azure/msal-angular';
import { Component, OnInit, Input, Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { HistoryService } from '../../../services/history.service';
import { History } from '../../../models/History';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-candidate-history',
  templateUrl: './candidate-history.component.html',
  styleUrls: ['./candidate-history.component.css'],
})
export class CandidateHistoryComponent implements OnInit {
  @Input() candidateID: string = '';
  displayLoader: boolean = true;
  mobileView: boolean = false;
  loginDisplay = false;
  loading: boolean = true;
  name: any;
  email: any;
  historyList: any;
  selected: string = 'history';
  id: string = '';
  public model: any;
  history: History[] = [];
  pageSizeOptions = [10, 20, 50, 100];
  page: any = 1;
  pageSize: any = 10;
  collectionSize = 10;

  constructor(
    private http: HttpClient,
    private authService: MsalService,
    private route: ActivatedRoute,
    private historyService: HistoryService,
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration
  ) { }

  ngOnInit(): void {
    this.refreshHistory();
  }
  public refreshHistory = (
    page: string = '1',
    query: string = '',
    pageSize: string = '10'
  ) => {
    this.loading = true;
    this.page = page;
    this.pageSize = pageSize;
    this.history = [];
    this.historyService
      .getEditHistory(
        this.page.toString(),
        this.pageSize,
        `${environment.apiConfig.uri}/admin/Candidates/EditHistory/` +
        this.candidateID
      )
      .subscribe((response: any) => {
        this.history = response.data.filter((record: any) => record.display !== "Herefish Score");
        this.collectionSize = response.extraParam.totalCount;
        this.loading = false;
      });
  };
  ngAfterViewInit() {
    if (window.screen.width <= 768) {
      this.mobileView = true;
    }
  }
}
